import React from "react";
import { Form } from "antd";
import type { FormInstance } from "antd/es/form";

import BaseModal from "./BaseModal";

interface FormModalProps {
  title: string;
  open: boolean;
  onCancel: () => void;

  form: FormInstance;
  onFinish: (values: any) => void;

  formId: string;

  isSubmitting?: boolean;
  submitLabel?: string;
  cancelLabel?: string;

  error?: string | null;

  children: React.ReactNode;

  afterClose?: () => void;
}

export default function FormModal({
  title,
  open,
  onCancel,
  form,
  onFinish,
  formId,
  isSubmitting,
  submitLabel,
  cancelLabel,
  error,
  children,
  afterClose,
}: FormModalProps) {
  return (
    <BaseModal
      title={title}
      open={open}
      onCancel={onCancel}
      formId={formId}
      isSubmitting={isSubmitting}
      submitLabel={submitLabel}
      cancelLabel={cancelLabel}
      error={error}
      afterClose={afterClose}
    >
      <Form id={formId} form={form} layout="vertical" onFinish={onFinish}>
        <div className="flex flex-col space-y-6">{children}</div>
      </Form>
    </BaseModal>
  );
}
